import styled from "styled-components"

import { minWidth } from "utils"

import Video from "components/video"

export const VideoContainer = styled(Video)`
  width: 100%;
  padding: 0 0 4rem;

  ${minWidth.tablet`
    padding: 0 4rem 4rem;
  `}

  ${minWidth.hamburgerLarge`
    padding: 0 4rem 6rem;
  `}
`
